import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-svg-wrapper',
  templateUrl: './svg-wrapper.component.html',
  styleUrls: ['./svg-wrapper.component.scss'],
})
export class SvgWrapperComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
